import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { Footer } from '@pages/principal/footer/footer';
import { Nav } from '@pages/principal/nav/nav';
import { TermsAndConditionsContentComponent } from '@shared/components/terms-and-conditions-content/terms-and-conditions-content.component';

@Component({
    selector: 'app-terms-and-conditions-page',
    standalone: true,
    imports: [Nav, Footer, RouterLink, TermsAndConditionsContentComponent],
    templateUrl: './terms-and-conditions.component.html',
    styleUrl: './terms-and-conditions.component.scss'
})
export class TermsAndConditionsPageComponent {

}
